/* eslint-disable react/prop-types */
/* eslint-disable react/forbid-prop-types */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { graphql, useStaticQuery } from 'gatsby';
import MainProvider from '~context/MainProvider';
import { getCookie } from "~helpers/cookies";
import Body from '~pages/body';
import HeadData from '~organisms/head';
import { getAPIData } from '~helpers/server-data';

const AppSSR = ({ pageContext, serverData }) => {

  const data = useStaticQuery(graphql`
    query {
      translations: allTranslation(filter: {}) {
        edges {
          node {
            key
            language
            value
          }
        }
      }
    }
  `);

  const [isAdmin, setIsAdmin] = useState(false);


  useEffect(() => {

    if (
      typeof window !== `undefined` &&
      getCookie("showAdminBar") === "true"
    ) {
      setIsAdmin(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);



  return (
    <>
      <MainProvider value={{ admin: isAdmin, translations: data.translations, language: pageContext.page.language  }}  >
        <Body pageContext={pageContext} serverData={serverData} />
      </MainProvider>
    </>
  );
};

export const Head = ({ pageContext }) => (
  <HeadData page={pageContext.page} siteInfo={pageContext.siteInfo} />
);

AppSSR.propTypes = {
  pageContext: PropTypes.shape({
    siteName: PropTypes.string,
    isTracker: PropTypes.bool,
    isPreview: PropTypes.bool,
    page: PropTypes.shape({
      id: PropTypes.number,
      path: PropTypes.string,
    }),
    translations: PropTypes.object,
    siteInfo: PropTypes.shape({
      robots_txt: PropTypes.string,
      site_logo: PropTypes.string,
      site_name: PropTypes.string,
    }),
    siteSchema: PropTypes.shape({
      site_name: PropTypes.string,
    }),
  }),
  serverData: PropTypes.any,
};

export default AppSSR;

export async function getServerData(props) {
  // eslint-disable-next-line no-shadow
  const { pageContext, url, headers } = props;
  let res = '';
  res = await getAPIData(pageContext.page, url, headers);
  return res;
}
